import React from "react";
import { render } from "react-dom";
import CookieModal from "../widgets/cookie";


let cookieModalEl = document.querySelector("#cookieModal");
if (cookieModalEl) render(<CookieModal elem={cookieModalEl} />, cookieModalEl);